/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVisitDto } from '../../models/create-visit-dto';
import { ResponseVisitDto } from '../../models/response-visit-dto';

export interface VisitsControllerCreate$Params {
      body: CreateVisitDto
}

export function visitsControllerCreate(http: HttpClient, rootUrl: string, params: VisitsControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseVisitDto>> {
  const rb = new RequestBuilder(rootUrl, visitsControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseVisitDto>;
    })
  );
}

visitsControllerCreate.PATH = '/thalea-pathways/visits';
